import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { createAppointmentModalStateAtom } from './CreateAppointmentModal.state';

export function useCreateAppointmentModal() {
  const setModalState = useSetRecoilState(createAppointmentModalStateAtom);

  const openCreateAppointmentModal = useCallback(
    (params = {}) => {
      setModalState({ open: true, ...params });
    },
    [setModalState],
  );

  const closeCreateAppointmentModal = useCallback(() => {
    setModalState({ open: false });
    // New Appointment launcher is an <a onClick>; browser focus outline
    // remains after Cancel/Esc. Blur so the item returns to normal.
    requestAnimationFrame(() => {
      if (
        document.activeElement &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur();
      }
    });
  }, [setModalState]);

  return {
    openCreateAppointmentModal,
    closeCreateAppointmentModal,
  };
}
